<script>
/* eslint-disable */

import {checaDisponibilidade, sincronizar} from "@/domain/integra/services/porto-remocao"

export default {
  name: 'PortoRemocaoPrincipal',
  inject: ['page'],
  mixins: [],
  components: {},
  data() {
    return {
      loading: true,
      sincronizando: false,
      disponibilidade: null
    }
  },
  computed: {
    contas() {
      return (this.disponibilidade && Array.isArray(this.disponibilidade.contas)) ? this.disponibilidade.contas : []
    }
  },
  mounted() {
    this.page.setActive('basic')
    document.querySelector('.u-erp-layout-container').classList.add('app-globalconfig')
    this.checaDisponibilidade()
  },
  beforeDestroy() {
    document.querySelector('.u-erp-layout-container').classList.remove('app-globalconfig')
  },
  methods: {
    checaDisponibilidade() {
      this.loading = true
      checaDisponibilidade()
        .then(({data}) => {
          this.loading = false
          this.disponibilidade = data
        })
        .catch(error => {
          this.loading = false
          this.alertApiError(error)
        })
    },
    sincronizar() {
      this.sincronizando = true
      this.$uloc.loading.show({message: 'Sincronizando salvados com a Porto Seguro...'})
      sincronizar()
        .then(({data}) => {
          this.sincronizando = false
          this.$uloc.loading.hide()
          const r = data.resumo || {}
          let message = `Processados: ${r.processados || 0} | Criados: ${r.criados || 0} | Atualizados: ${r.atualizados || 0} | Falhas: ${r.falhas || 0}`
          const porConta = r.porConta || {}
          const ids = Object.keys(porConta)
          if (ids.length > 1) {
            message = message + ids.map(id => {
              const c = porConta[id]
              return `\n${c.nome}: ${c.criados || 0} criados, ${c.atualizados || 0} atualizados, ${c.falhas || 0} falhas`
            }).join('')
          }
          this.$uloc.dialog({
            title: 'Sincronização concluída',
            message: message,
            color: (r.falhas ? 'warning' : 'positive')
          })
        })
        .catch(error => {
          this.sincronizando = false
          this.$uloc.loading.hide()
          this.alertApiError(error)
        })
    }
  }
}
</script>

<template>
  <div class="flex col-grow no-wrap globalconfigs-container">
    <transition name="slide" appear>
      <div class="transition-generic w-full">
        <div class="global-config-container">
          <div class="m-t m-b-lg">
            <h2 class="component-title">Integração de Remoção de Salvados — Porto Seguro</h2>

            <div class="m-t-lg">
              <div v-if="loading">
                <i class="fa fa-spin fa-spinner"></i> Aguarde enquanto verificamos a disponibilidade do ambiente.
              </div>
              <div v-if="!loading && disponibilidade">
                <div class="erp-terminal" style="padding: 30px; color: #b6ffa7 !important;">
                  Ambiente disponível:
                  <span v-if="disponibilidade.disponivel">Sim</span>
                  <span v-else>Não — configure as contas (integra.ws.porto.remocao.contas)</span>
                  <template v-if="disponibilidade.comitente">
                    <br><br>Comitente Porto (id): {{ disponibilidade.comitente }}
                  </template>
                  <template v-if="contas.length">
                    <br><br>{{ contas.length > 1 ? 'Contas (login por pátio):' : 'Conta:' }}
                    <br>
                    <span v-for="c in contas" :key="c.id">
                      · {{ c.nome }} — login {{ c.login }}<template v-if="c.patio"> — pátio #{{ c.patio }}</template><template v-if="!c.active"> (inativa)</template>
                      <br>
                    </span>
                  </template>
                </div>

                <div class="m-t-lg">
                  <e-btn :loading="sincronizando" label="Sincronizar salvados agora" @click="sincronizar"
                         :disable="!disponibilidade.disponivel"/>
                  <e-btn class="m-l-sm" label="Ver salvados em remoção"
                         @click="$router.push({name: 'integra.porto-remocao.salvados'})"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
